<template>
  <v-flex xs10 offset-xs1 lg4 offset-lg4 class="margin">
    <div class="white elevation-2">
      <v-toolbar flat dense dark>
        <v-toolbar-title>Acceder a la plataforma</v-toolbar-title>
      </v-toolbar>
      <div class="pl-4 pr-4 pt-2 pb-2">
        <form name="login-form" autocomplete="off">
          <v-text-field
            prepend-icon="person"
            name="name"
            type="text"
            label="Nombre"
            v-model="name"
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            name="password"
            type="password"
            label="Contraseña"
            v-model="password"
            autocomplete="new-password"
          ></v-text-field>
        </form>
        <v-flex xs12 lg6 lg-offset3 align="center">
          <v-btn
            dark
            @click="login">Acceder
          </v-btn>
        </v-flex>
      </div>
    </div>
    <v-snackbar
      :timeout=6000
      :color="color"
      :multi-line="'multi-line'"
      v-model="snackbar">
      <v-icon dark>error_outline</v-icon>
      {{ error }}
      <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
/* eslint-disable */
  import AuthenticationService from '@/services/AuthenticationService';
  import '@/assets/css/custom.css'

  export default {
    data() {
      return {
        name: '',
        password: '',
        error: null,
        snackbar: false,
        color: ''
      };
    },
    methods: {
      async login() {
        try {
          const response = await AuthenticationService.login({
            name: this.name,
            password: this.password
          })
          this.$store.dispatch('setToken', response.data.token)
          this.$store.dispatch('setUser', response.data.user)
          this.$store.dispatch('setError', null)
          this.$router.push({
            name: 'dashboard'
          })
        } catch (err) {
          this.error = err.response.data.msg
          this.snackbar = true
          this.color = 'error'
        }
      }
    },
  };
</script>


<style scoped>
  .margin {
    margin-top: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/signin/SignIn.vue